import Vue from 'vue';

import DialogoBuscarProdutos from "./DialogoBuscarProdutos";
// import DialogoBuscarClientes from "./DialogoBuscarClientes";

Vue.component('DialogoBuscarProdutos', DialogoBuscarProdutos);
// Vue.component('DialogoBuscarClientes', DialogoBuscarClientes);